import { NotificationTopicOwnersSettingsSection } from "@/components/NotificationTopicOwnersSettingsSection";
import { PageTitleWithHelp } from "@/components/ui/title-help";
import { apiFetch } from "@/lib/api";
import { useHubModuleAdmin } from "@/lib/useHubModuleAdmin";

const NOTIFICATION_STAFF_USERS_QUERY_KEY = ["notifications", "staff-user-options"] as const;

function fetchNotificationStaffUsers(): Promise<{
  users: Array<{ userId: string; email: string; displayName: string | null }>;
}> {
  return apiFetch("/api/notifications/staff-user-options");
}

export function EngineeringSettingsPage() {
  const canEdit = useHubModuleAdmin("engineering");

  return (
    <div className="space-y-4">
      <header>
        <PageTitleWithHelp hoverHint="Engineering module settings: firmware notification distribution lists and other operational configuration.">
          Engineering · Settings
        </PageTitleWithHelp>
      </header>

      <NotificationTopicOwnersSettingsSection
        topic="engineering_firmware_received"
        title="Firmware received distribution"
        hoverHint="Hub users in this group receive email and in-app notifications when a new firmware file is uploaded and marked Received."
        canEdit={canEdit}
        userOptionsQueryKey={NOTIFICATION_STAFF_USERS_QUERY_KEY}
        fetchUserOptions={fetchNotificationStaffUsers}
        readOnlyHoverHint="Engineering module administrators can edit this distribution list."
      />

      <NotificationTopicOwnersSettingsSection
        topic="engineering_firmware_approved"
        title="Firmware approved distribution"
        hoverHint="Hub users in this group receive email and in-app notifications when a firmware file is approved."
        canEdit={canEdit}
        userOptionsQueryKey={NOTIFICATION_STAFF_USERS_QUERY_KEY}
        fetchUserOptions={fetchNotificationStaffUsers}
        readOnlyHoverHint="Engineering module administrators can edit this distribution list."
      />
    </div>
  );
}
